import { useCallback } from 'react';
import { RootState } from 'store';
import { useSelector } from 'react-redux';
import { StationCode } from 'dataSources/Typicode/stations/types';
import {
  SearchStation,
  Station,
} from 'dataSources/Typicode/stations/types/station';
import { EMPTY_STRING } from 'common/constants';
import { STATE, IState } from '../types/state';

export const allStationsMap = (
  state: RootState,
): IState['allStations']['dataMap'] => {
  const {
    allStations: { dataMap },
  } = state[STATE];
  return dataMap;
};

export const useAllStationsMap = () => {
  const { dataMap } = useSelector(
    (state: RootState) => state[STATE].allStations,
  );
  return dataMap;
};

export const useGetStationByCode = () => {
  const allStations = useSelector(allStationsMap);

  const getStationByCode = useCallback(
    (stationCode?: StationCode) => allStations[stationCode || EMPTY_STRING],
    [allStations],
  );

  return getStationByCode;
};

export const useGetStationsByCodes = () => {
  const getStationByCode = useGetStationByCode();

  const getStationsByCodes = useCallback(
    (stationCodes?: SearchStation[]) => {
      if (!stationCodes) {
        return [];
      }

      return stationCodes.reduce((acc, stationCode) => {
        const station = getStationByCode(stationCode.code);
        if (station) {
          acc.push({ ...station, ...stationCode });
        }
        return acc;
      }, [] as Station[]);
    },
    [getStationByCode],
  );

  return getStationsByCodes;
};

export const useMappingStationsByCodes = (stationCodes?: StationCode[]) => {
  const getStationsByCodes = useGetStationsByCodes();

  return getStationsByCodes(
    stationCodes
      ? stationCodes.reduce((acc, code) => {
          acc.push({ code });
          return acc;
        }, [] as SearchStation[])
      : undefined,
  );
};

export const useStationByCode = (stationCode?: StationCode) => {
  const getStationByCode = useGetStationByCode();
  return getStationByCode(stationCode);
};
